import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormField } from "ui";

import { ProductFormValues } from "../ProductDetailsForm.types";

import styles from "../ProductDetailsForm.module.scss";

export const ChoiceBlock = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProductFormValues>();

  return (
    <div className={styles.productForm__block}>
      <Controller
        control={control}
        name={"isChapshopChoice"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField label={t("Chapshop Choice")} errorMessage={error?.message}>
            <Checkbox
              checked={value}
              onChange={onChange}
              label={t("Mark as Chapshop Choice")}
            />
          </FormField>
        )}
      />
    </div>
  );
};
